export default "__VITE_ASSET__94cef76a__"